import React, { useEffect, useRef, useState } from 'react';
import { Button, Input, ModalBody, ModalFooter, ModalHeader, Spinner, User } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { AuthService, TeacherChatService } from '../../../services';
import moment from 'moment';
import { classNames, Constants, formatAmount, fromPhotos } from '../../../utils';
import { IconSearch } from '@tabler/icons-react';



const NewChat = ({ onSuccess }) => {
  const [form, setForm] = useState({
    search: '',
  });
  const { filterBy, data } = useForm();

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  const submit = async (item) => {
    const chat = item?.parent_chats?.length > 0 ? item?.parent_chats[0] : null;
    onSuccess({
      id: chat?.id,
      user: item
    })
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Nuevo chat</ModalHeader>
      <ModalBody className="gap-8 relative">
        <Input
          classNames={{
            inputWrapper: 'border-1',
          }}
          label="Buscar representante"
          labelPlacement="outside"
          placeholder="Nombre del representante"
          startContent={<IconSearch />}
          variant="bordered"
          radius="sm"
          value={form.search}
          onValueChange={v => onChange(v, 'search')}
        />

        <div className=''>
          {
            data.length > 0 ? (
              data.map((item, index) => {
                return (
                  <div
                    key={index}
                    className='mb-2 cursor-pointer hover:bg-gray/20 p-2 rounded-lg'
                    onClick={() => submit(item)}
                  >
                    <User
                      key={item.id}
                      avatarProps={{ showFallback: true, radius: 'full', src: item.photo ? fromPhotos(item.photo) : null }}
                      classNames={{ description: 'text-foreground-500', name: 'capitalize' }}
                      name={`${item.name} ${item.lastname}`}
                    />
                  </div>
                )
              })
            ) : (
              <p className="text-center">No hay representantes</p>
            )
          }
        </div>

      </ModalBody>
    </>
  )
}

const useForm = (type, initPayment) => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters)
  const [pagination, setPagination] = useState(initialPagination);
  const user = useSelector(state => state.user);

  const debounceTime = 500;
  const debounce = useRef();

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await TeacherChatService.chat.getParents({ ...filters, user_id: user.id });
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      toast.error(String(error));
    }
  }

  const getCurrentPagination = () => {
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setCanFetch(true);
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }

  useEffect(() => {
    fetchData()
  }, [filters])


  return {
    changePerPage,
    data,
    filters,
    filterBy,
    goToPage,
    isLoading: !canFetch,
    pagination,
    user
  }
}

export default NewChat;
